import useDateFormatter from "hooks/formatDateWithPattern";
import { RenderCellContentProps } from "../../types";
import ellipsize from "ellipsize";

export const RenderCellContent: React.FC<RenderCellContentProps> = ({
  columnDef,
  cellValue,
}) => {
  const { formatDate } = useDateFormatter();
  const getTextBackGroundColors = (name: string): string => {
    switch (name) {
      case "Processing":
        return "bg-accent_1Light text-accent_1Dark";
      case "Completed":
        return "bg-tertiaryExtraLight text-tertiaryMid";
      default:
        return "white";
    }
  };

  if (cellValue !== null && columnDef.id === "creationDate") {
    return (
      <div
        className={`relative flex items-center gap-2 flex-grow py-1 px-3`}
      >
        <p
          className={`text-sm text-left text-textMid whitespace-nowrap rounded-lg py-1 w-full`}
        >
          {formatDate(cellValue?.toString())}
        </p>
      </div>
    );
  } else if (
    (columnDef.id === "uploadStatus") &&
    cellValue !== null
  ) {
    return (
      <div className="flex justify-start">
        <p
          className={`text-sm py-1 px-2 rounded-lg capitalize ${getTextBackGroundColors(cellValue)}`}
        >
          {cellValue}
        </p>
      </div>
    );
  }else if (cellValue !== null) {
    return (
      <div
        className={`relative flex items-center gap-2 flex-grow py-1 px-3 ${
          columnDef.id === "file" || columnDef.id === "description"  ? "w-80" : ""
        }`}
      >
        <p
          className={`text-sm text-left text-textMid whitespace-nowrap rounded-lg py-1 capitalize w-full`}
        >
          {ellipsize(`${cellValue}`, 40)}
        </p>
      </div>
    );
  } 
  else {
    return null;
  }
};
